import {
  FinanceProfilePaymentFormsEnum,
  FinanceProfileTransactionPaymentMethodsEnum,
  ProfileSelectedDeliveryDaysEnum,
  ProfileSelectedDeliveryPeriodsEnum,
} from '@/types'

interface AcquisitionDataProps {
  monthlyBuyingPotential?: string
  purchaseFrequency?: string
  companyAge?: number
  selectedDeliveryPeriods?: (keyof typeof ProfileSelectedDeliveryPeriodsEnum)[]
  selectedDeliveryDays?: (keyof typeof ProfileSelectedDeliveryDaysEnum)[]
  productOfInterest?: string
  industry?: string
  companyManufacturedProduct?: string
}

export const checkCompletedAcquisitionData = (
  acquisitionData: AcquisitionDataProps,
): number => {
  const keys = Object.keys(acquisitionData) as (keyof AcquisitionDataProps)[]
  const total = keys.length

  const filled = keys.filter((key) => {
    const value = acquisitionData[key]
    return (
      value !== null &&
      value !== undefined &&
      value !== '' &&
      (Array.isArray(value) ? value.length > 0 : true)
    )
  }).length

  return (total === 0 ? 0 : filled / total) * 100
}

interface FinanceDataProps {
  enabledPaymentMethods?: (keyof typeof FinanceProfileTransactionPaymentMethodsEnum)[]
  enabledPaymentForms?: (keyof typeof FinanceProfilePaymentFormsEnum)[]
  cfdiUsage?: string | string[]
  preferredPaymentPlanType?: string | string[]
}

export const checkCompletedFinanceData = (
  financeData: FinanceDataProps,
): number => {
  const keys = Object.keys(financeData) as (keyof FinanceDataProps)[]
  const total = keys.length

  const filled = keys.filter((key) => {
    const value = financeData[key]
    return (
      value !== null &&
      value !== undefined &&
      value !== '' &&
      (Array.isArray(value) ? value.length > 0 : true)
    )
  }).length

  return (total === 0 ? 0 : filled / total) * 100
}
